if(!customElements.get('custom-article')){
    class MainArticle extends HTMLElement {
        constructor(){
            super();

            this.commentForm = this.querySelector(".comment-form");
        }

        connectedCallback(){
            this.onLoadNumberPaginationSubscriber = PubSub.subscribe(PubSub.events.onLoadNumberPagination, this.handleCommentsLoad.bind(this));
        
            const message = this.querySelector(".message");
            if(message){
                message.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start' 
                });
            }
        }

        disconnectedCallback(){
            if(this.onLoadNumberPaginationSubscriber && typeof this.onLoadNumberPaginationSubscriber === 'function'){
                this.onLoadNumberPaginationSubscriber();
            }
        }

        handleCommentsLoad({ data, callback }){
            if(data.type !== 'comment') return;

            this.pendingRequestUrl = data.url;
            const currentUrl = data.url || this.pendingRequestUrl;

            setTimeout(() => {
                this.renderContent({
                    requestUrl: `${currentUrl}`,
                    callback: this.loadCommentContent({
                        callback: callback
                    })
                });
            }, 500);
        }

        renderContent({ requestUrl, callback }){
            this.abortController?.abort();
            this.abortController = new AbortController();

             fetch(requestUrl, { signal: this.abortController.signal })
                .then(res => res.text())
                .then(resText => {
                    this.pendingRequestUrl = null;
                    const html = new DOMParser().parseFromString(resText, 'text/html');
                    callback(html);
                })
                .catch(error => {
                    if(error.name === 'AbortError') {
                        console.log('Fetch aborted by user');
                    }else{
                        console.error(error);
                    }
                });
        }

        loadCommentContent({ callback }){
            if(!this.commentForm) return;

            return (html) => {
                const commentsWrapper = html.querySelector('.article__comments');
                this.commentWrapper = this.querySelector(".article__comments");

                if(commentsWrapper){
                    this.commentWrapper.innerHTML = commentsWrapper.innerHTML;

                    const pagination = html.querySelector("number-pagination");
                    if(pagination){
                        callback(pagination);
                    }
                }
            }
        }
    }

    customElements.define('custom-article', MainArticle);
}